import {apiClient} from "@/state/modules/apiClient";
const controller = "citizen";
export const actions = {
    async register({commit}, values) {
        return apiClient.post(controller + "/register", values);
    },
    async login({commit}, values) {
        return apiClient.post(controller +"/login", values);
    },
    async getTree({commit}) {
        return apiClient.get(controller +"/getTree-donvi");
    },
    async updateCitizen({commit, dispatch}, values) {
        return apiClient.put(controller +"/update", values);
    },
    async changePassword({commit}, params) {
        return apiClient.post(controller + "/change-password",params);
    },
};
